function readCookieConsent() {
	const name = "cookiespool_consent";
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		const c = ca[i].trim();
		if (c.indexOf(name) == 0) {
			return JSON.parse(c.substring(name.length + 1, c.length));
		}
	}
	return null;
}

function createCookiespoolObject() {
	if (document.getElementById("cookiespool-modal-container") !== null &&
		document.getElementById("cookiespool-modal-container") !== undefined) {
		window.cookieSpool.openSettings();
	}
	else {
		setTimeout(() => {
			cookiespoolBannerPopupInitiate();
		}, 300);
	}
}

function cookiespoolBannerPopupInitiate() {
	window.cookieSpool = new CookieSpool({
		tenantId: "94e0f1dc-1c16-4b93-875f-fa54cbd1dcab",
		siteId: "255befbf-6cc9-4300-b6e8-2ae02a634d67",
		language: document.documentElement.lang,
		enableClose: false,
		onChangeSettings: consent => {
			triggerGTMTagSettings(consent);	// GTM Settings	
			gtag({ "event": "Pageview" });	// GTM Pageview
		}
	});
}

// GTM update consent entegrasyon fonksiyonu
function triggerGTMTagSettings(parConsent) {
	gtag("consent", "update", {
		"ad_storage": parConsent.choices.marketing ? "granted" : "denied",
		"analytics_storage": parConsent.choices.performance ? "granted" : "denied",
		"functionality_storage": parConsent.choices.functional ? "granted" : "denied",
		"personalization_storage": parConsent.choices.functional ? "granted" : "denied",
		"ad_user_data": parConsent.choices.marketing ? "granted" : "denied",
		"ad_personalization": parConsent.choices.marketing ? "granted" : "denied",
		"wait_for_update": 2000
	});
	gtag("event", "cookiespool_consent_update");
}

window.dataLayer = window.dataLayer || [];
function gtag() {
	dataLayer.push(arguments);
}

const consent = readCookieConsent();
if (consent !== null && consent.userId !== null) {
	triggerGTMTagSettings(consent);	// GTM Settings
}
createCookiespoolObject();